/**
 * Data attributes to ignore password managers on input fields.
 *
 * These attributes tell various password managers to ignore the field,
 * preventing them from auto-filling or suggesting passwords.
 */
export const IGNORE_PASSWORD_MANAGERS = {
  'data-1p-ignore': 'true', // 1Password
  'data-bwignore': 'true', // Bitwarden
  'data-lpignore': 'true', // LastPass
  'data-protonpass-ignore': 'true', // Proton Pass
  'data-form-type': 'other', // Dashlane
} as const;
